import * as Yup from 'yup';

import { ALLOWED_CHARACTERS_REGEX, MAX_FILE_SIZE_10MB, PHONE_REGEX } from '@/common/constants';

export const shipOwnerSchema = () => {
    return (
        Yup.object({
            onBehalfCompany: Yup.string()
                .trim()
                .required('On Behalf Company is required')
                //.matches(ALLOWED_CHARACTERS_REGEX, 'Input must only contain alphabets, numbers, commas, dots, slashes, and dashes.')
                .max(50, 'Max length is 50 characters'),
            address: Yup.string()
                .trim()
                .required('Address is required'),
            country: Yup.string()
                .trim()
                .required('Country is required'),
            contactPerson: Yup.string()
                .trim()
                .required('Contact person is required')
                .matches(ALLOWED_CHARACTERS_REGEX, 'Input must only contain alphabets, numbers, commas, dots, slashes, and dashes.')
                .max(50, 'Max length is 50 characters'),
            email: Yup.string()
                .trim()
                .required('Email is required')
                .email('Enter a valid email address')
                .max(50, 'Max length is 50 characters'),
            alternateEmail: Yup.string()
                .trim()
                .email('Enter a valid email address')
                .max(50, 'Max length is 50 characters'),
            phone: Yup.string()
                .trim()
                .matches(PHONE_REGEX, 'Phone number must contain only digits or a "+" sign')
                .max(15, 'Max length is 15 characters'),
            doc: Yup.mixed()
                    .nullable()
                    .test('fileSize', 'File size is too large', (value) => {
                        if (value && (value as File).size > MAX_FILE_SIZE_10MB) {
                            return false;
                        }
                        return true;
                    })
        }))
};
